<template>
    <b-form-row>
        <b-modal size="xl" :id="id" ref="finder" hide-footer :title="prefix + title">
            <TipoManutencaoIbp @close="rowSelect" :prefix="prefix + title + ' >'" />
        </b-modal>
        <lg-form-input-finder v-model="localValue" fieldDescription="descricao" :label="label"
            invalidFeedback="Tipo Manutenação IBP deve ser informado!" description="" @handleClean="handleClear">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import TipoManutencaoIbp from "@/modules/patrimonio/solicitacao-manutencao/TipoManutencaoIbp.vue";
export default {
    components: { LgFormInputFinder, TipoManutencaoIbp },

    props: {
        id: {
            type: String,
            default: "finderTipoManutencaoIBP",
        },
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Tipo Manutenação IBP:",
        },
    },

    data() {
        return {
            localValue: this.value,
            title: "Tipo Manutenação IBP",
        };
    },

    watch: {
        value(newValue) {
            this.localValue = newValue;
        },
        localValue(newValue) {
            this.$emit("input", newValue);
        },
    },

    methods: {
        async show() {
            await this.$refs.finder.show();
        },

        handleClear() {
            this.localValue = null;
            this.$emit("input", null);
        },

        rowSelect(item) {
            this.localValue = item;
            this.$refs.finder.hide();
            this.$emit("input", item);

        },
    },
};
</script>
